import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonItem, IonInput, IonButton, IonIcon, IonSpinner, IonNote, IonButtons } from '@ionic/angular/standalone';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { TranslateService } from 'src/assets/translate.service';
import { AuthService } from '../../services/auth.service';
import { ModalService } from '../../services/modal.service';
import { Subscription } from 'rxjs';
import { addIcons } from 'ionicons';
import { close, logInOutline } from 'ionicons/icons';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule, FormsModule, TranslatePipe,
    IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonItem,
    IonInput, IonButton, IonIcon, IonSpinner, IonNote, IonButtons, RouterLink
  ]
})
export class LoginModalComponent implements OnDestroy {
  email = '';
  password = '';
  loginError = '';
  isSubmitting = false;

  private languageChangeSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private modalService: ModalService,
    private translateService: TranslateService,
  ) {
    addIcons({ close, logInOutline });
    this.languageChangeSubscription = this.translateService.languageChanged.subscribe(() => {
      this.loginError = '';
    });
  }

  async login(): Promise<void> {
    if (this.isSubmitting) return;

    this.isSubmitting = true;
    this.loginError = '';

    try {
      await this.authService.login(this.email, this.password);
      this.closeModal();
    } catch (error: any) {
      this.loginError = error.message;
    } finally {
      this.isSubmitting = false;
    }
  }

  async openForgotPasswordModal(): Promise<void> {
    await this.modalService.dismiss();
    this.modalService.openForgotPasswordModal();
  }

  closeModal(): void {
    this.modalService.dismiss();
  }

  ngOnDestroy(): void {
    this.languageChangeSubscription.unsubscribe();
  }
}